/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import Grid from './gridComponents/grid';
import {
  manuFactureChildHead,
  manuFactureHead,
  groupTableHeadCC,
  superClientModalHead,
  clientGroupPlanHead,
  contractTableHead,
} from './gridComponents/tableHead';
import { providerData } from './mockData';

function CopyContact(props) {
  const { entityType } = props;
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(entityType);
  const [childData, setChildData] = useState([]);
  const [cgData, setCgData] = useState([]);
  const [cgpData, setCgpData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [mfgData, setMfgData] = useState([]);
  const [contractData, setContractData] = useState([]);
  const { setSelectedContact } = props;

  useEffect(() => {
    getClientCodeValues();
    getAllClientGroupsForCopyContact();
    getAllClientGroupPlanForCopyContact();
    getAllClientForCopyContact();
    getAllManufacturer();
    getAllContractForCopyContact();
  }, []);

  const getClientCodeValues = () => {
    axios
      .get(serviceEndPoint.GET_CLIENT_CODE_VALUES)
      .then((res) => {
        if (res && res.data && res.data.length > 0) {
          setSelectOptions(
            res.data.map((x) => {
              return {
                text: x.longDescription,
                value: x.codeValueID.codeValue,
              };
            })
          );
        }
      })
      .catch((err) => {});
  };

  const getAllClientGroupsForCopyContact = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT)
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          setCgData(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const getAllClientGroupPlanForCopyContact = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT)
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          setCgpData(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const getAllClientForCopyContact = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENT_FOR_COPY_CONTACT)
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          setClientData(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const getAllManufacturer = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENT_MANUFACTURER, {
        showAllInd: true,
        mfgId: null,
      })
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          setMfgData(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const getAllContractForCopyContact = () => {
    axios
      .post(serviceEndPoint.GET_ALL_CONTRACT_FOR_COPY_CONTACT, {
        showAllInd: true,
        mfgId: null,
      })
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          setContractData(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const handleOpen = (e) => {
    if (setSelectedContact) setSelectedContact(null);
    getSelectedRow(e, (data) => {
      setChildData(data);
    });
  };

  const childSelect = (e) => {
    if (setSelectedContact) setSelectedContact(e.data);
  };

  const getSelectedRow = (e, callBack) => {
    switch (selectedOption) {
      case 'CG':
        getExistingContacts(e.data.cg_id, 'CG', callBack);
        break;
      case 'CGP':
        getExistingContacts(e.data.planId, 'CGP', callBack);
        break;
      case 'CLIENT':
        getExistingContacts(e.data.clientId, 'CLIENT', callBack);
        break;
      case 'CONTRACT':
        getExistingContacts(e.data.contractNum, 'CONTRACT', callBack);
        break;
      case 'MFG':
        getExistingContacts(e.data.mfgId, 'MFG', callBack);
        break;
      case 'PROVIDER':
        getExistingContacts(e.data, 'PROVIDER'); // hold for now
        break;
      default:
        break;
    }
  };

  const getExistingContacts = (key, keyTypeCd, callBack) => {
    const payload = {
      key: [key],
      keyTypeCd: keyTypeCd,
    };
    axios
      .post(serviceEndPoint.GET_EXISTING_CONTACT_DETAILS, payload)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          callBack(response.data);
        }
      })
      .catch((error) => {
        callBack([]);
      });
  };

  const onSelect = (e) => {
    setSelectedOption(e.target.value);
  };

  const CurrentComp = () => {
    switch (selectedOption) {
      case 'CG':
        return (
          <Grid
            rowData={cgData}
            columnDefs={groupTableHeadCC}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      case 'CGP':
        return (
          <Grid
            rowData={cgpData}
            columnDefs={clientGroupPlanHead}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      case 'CLIENT':
        return (
          <Grid
            rowData={clientData}
            columnDefs={superClientModalHead}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      case 'CONTRACT':
        return (
          <Grid
            rowData={contractData}
            columnDefs={contractTableHead}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      case 'MFG':
        return (
          <Grid
            rowData={mfgData}
            columnDefs={manuFactureHead}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      case 'PROVIDER':
        return (
          <Grid
            rowData={providerData}
            columnDefs={manuFactureHead}
            cellClickedListener={handleOpen}
            gridHeight="200"
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <DisplayErrorMessages errorMessages={[]} />
      <DisplaySuccessMessages successMessages={[]} />
      <div className="copy-contact-min-width">
        <div className="tab-body">
          <div>
            <form autoComplete="off">
              <div className="tab-holder outline_border">
                <div className="row mb-2">
                  <div className="col-4" style={{ maxWidth: '398px' }}>
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95">
                        <TextField
                          label={props.Manufacturer ? false : 'Entity Type'}
                          defaultValue={selectedOption}
                          fullWidth
                          required
                          select
                          placeholder=""
                          inputProps={{ maxlength: 11 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={selectedOption}
                          onChange={onSelect}
                        >
                          {selectOptions.map((x) => {
                            return (
                              <MenuItem key={x.value} value={x.value}>
                                {x.text}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </div>
                    </div>
                  </div>
                  <div className="col-4" style={{ maxWidth: '398px' }}>
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={<Checkbox color="primary" />}
                          label="Show All"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div>
            <CurrentComp />
            <div className="float-right mt-2  mb-2 hide-on-print" />
            <div className="clearfix" />
            <p>Available Contacts</p>
            <div className="clearfix" />
            <Grid
              rowData={childData}
              columnDefs={manuFactureChildHead}
              gridHeight="200"
              cellClickedListener={childSelect}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default withRouter(CopyContact);
